export default __webpack_public_path__ + "static/media/art.7d3cabda.svg";